import { observable, action, computed } from "mobx";
import { BaseOfferMenuStore } from "@state/stores/offer/shared/BaseOfferMenuStore";
import { history } from "@state";
import { TSection } from "@data-types/offer/live/Section";

export class LivePeriodSubMenuStore {
	private parentMenu: {
		menu: BaseOfferMenuStore["menu"];
		rootStore: BaseOfferMenuStore["rootStore"];
		deselectSport: (sp: any) => void;
		closeOfferMenu: () => void;
	};

	constructor(parentMenu: LivePeriodSubMenuStore["parentMenu"]) {
		this.parentMenu = parentMenu;
	}

	@observable public selectedPeriodKey: TSection = TSection.Matches;
	@observable public prevPeriod = TSection.Matches;

	/** @deprecated this returns selected period key */
	@computed get selectedPeriod() {
		return { period: this.selectedPeriodKey };
	}

	@action.bound
	setPeriodKey(period: TSection) {
		if (this.selectedPeriodKey === period) {
			return;
		}

		this.prevPeriod = this.selectedPeriodKey;
		this.selectedPeriodKey = period;

		if (this.selectedPeriodKey !== TSection.Matches) {
			if (history.action !== "POP") {
				this.parentMenu.menu.onCheck(false);
			}
			this.parentMenu.deselectSport(null);
			this.parentMenu.closeOfferMenu();
		}

		// Scroll to top of the page on period change
		window.scroll(0, 0);
	}
}
